import { createReducer } from 'redux-orm';
import reducers from './reducers';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';

export default createReducer(orm, reducers);
